import React, { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { CalendarClock, CalendarPlus, Zap } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const SchoolGroup = ({ g, onDone }) => {
  const [date, setDate] = useState("");
  const [busy, setBusy] = useState(false);
  const schedule = async () => {
    setBusy(true);
    try {
      await api.post("/fdp-list/schedule", { item_ids: g.items.map((i) => i.id), date });
      toast.success(`Agendado: ${g.name}`);
      onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro ao agendar"); } finally { setBusy(false); }
  };
  return (
    <li className="p-3 rounded-xl border border-slate-200 bg-white" data-testid={`to-schedule-${g.id}`}>
      <p className="text-[13px] font-bold text-slate-900">{g.name} <span className="text-[11px] font-semibold text-slate-500">· {g.items.length} item(ns)</span></p>
      <ul className="mt-1 space-y-0.5">
        {g.items.map((i) => (
          <li key={i.id} className="text-[12px] text-slate-700 flex gap-1">
            {i.priority === "urgente" ? <Zap className="w-3 h-3 text-rose-600 mt-0.5 shrink-0" /> : <span className="text-slate-300">•</span>}
            <span className="break-words">{i.quantity > 1 && `${i.quantity}× `}{i.description}</span>
          </li>
        ))}
      </ul>
      <div className="flex gap-2 mt-2">
        <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="h-9 flex-1 min-w-0" data-testid={`to-schedule-date-${g.id}`} />
        <Button size="sm" disabled={!date || busy} onClick={schedule} className="bg-fuchsia-600 hover:bg-fuchsia-700 text-white h-9" data-testid={`to-schedule-btn-${g.id}`}>
          <CalendarPlus className="w-4 h-4 mr-1" /> Agendar
        </Button>
      </div>
    </li>
  );
};

// Itens das Listas FDP ainda sem data no cronograma.
export default function FdpToScheduleCard() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/fdp-list", { params: { scope: "to_schedule" } }).then((r) => setItems(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const groups = useMemo(() => {
    const g = {};
    items.forEach((i) => { (g[i.school_id] = g[i.school_id] || { id: i.school_id, name: i.school_name, items: [] }).items.push(i); });
    return Object.values(g);
  }, [items]);
  if (!groups.length) return null;
  return (
    <div className="bg-fuchsia-50/60 border border-fuchsia-200 rounded-2xl p-4 space-y-2" data-testid="fdp-to-schedule-card">
      <div className="flex items-center gap-2">
        <CalendarClock className="w-5 h-5 text-fuchsia-700" />
        <p className="font-heading font-black text-sm text-fuchsia-900 flex-1">A agendar — Listas FDP ({items.length})</p>
        <Link to="/solicitacoes" className="text-[11px] font-bold text-fuchsia-700 hover:underline">Ver listas</Link>
      </div>
      <ul className="space-y-2">{groups.map((g) => <SchoolGroup key={g.id} g={g} onDone={load} />)}</ul>
    </div>
  );
}
